export function NoThumbnail() {
    return <div className='no-thumbnail'>
        <p>עדיין אין טאמבנייל</p>
    </div>
}